import {useRef, useState} from 'react'
import {message} from "antd";
import {
  SActionBtn,
  SLowcodeList, SMessage,
  STableActions,
} from 'shj-components'
import {getLineAllocationPage, lineAllocationDel} from "@/services/crmTool.ts";
import {apiData2Table} from "@/utils/data.ts";

import {AddOrEdit} from "./AddOrEdit";
import {config} from './config.tsx'
import {getEnums, httpOrgList} from "@/services/homeService.ts";

export default function LineAllocation() {
  const listRef = useRef()
  const [open, setOpen] = useState(false)
  const [record, setRecord] = useState({})

  const fetchList = ({current, pageSize, query}) => {
    return new Promise((resolve, reject) => {
      getLineAllocationPage({params: {pageId: current, pageSize}, data: {...query}}).then((res: any) => {
        resolve(apiData2Table(res))
      }).catch(reject)
    })
  }

  const onAdd = () => onEdit()
  const onEdit = (record = {}) => {
    setOpen(true)
    setRecord(record)
  }

  //  表格事件: 删除
  const onDel = id => {
    SMessage.confirm({
      onOk: () => {
        return lineAllocationDel(id).then((res: any) => {
          message.success(res.message || '操作成功');
          listRef.current?.reload()
        })
      },
    });
  }

  const getStatusOptions = async () => {
    const companyList = await httpOrgList();
    const brandEnum = await getEnums('crm-tools', 'com.shj.saas.crm.tools.enums.seat.BrandEnum');
    return Promise.resolve({companyList, brandEnum})
  }

  const extensions = {
    request: {fetchList, getStatusOptions},
    events: {onAdd},
    customRender: {
      actionRender(_, record: Record<string, any>) {
        return (
            <STableActions>
              <SActionBtn onClick={() => onEdit(record)}>编辑</SActionBtn>
              <SActionBtn danger onClick={() => onDel(record.id)}>删除</SActionBtn>
            </STableActions>
        )
      },
    },
  }
  return (<>
    <SLowcodeList ref={listRef} searchMode="group" config={config} {...extensions} />
    {open && <AddOrEdit open={open}
                        record={record}
                        onReload={listRef.current?.reload}
                        setOpen={(open: boolean) => setOpen(open)}
    />}
  </>)
}
